import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TextField, Typography, IconButton, Box
} from '@mui/material';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import { getDecryptedAccessToken } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import ApiServices from '../../../Utils/ApiServices/ApiServices';

const AllWorkOuts = ({ onWorkoutsClick }) => {
  const [workouts, setWorkouts] = useState([]);
  const [filteredWorkouts, setFilteredWorkouts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const accessToken = getDecryptedAccessToken();

  useEffect(() => {
    const fetchWorkouts = async () => {
      try {
        const response = await ApiServices.get('/apis/default/api/workoutplans',  {
            Authorization: `Bearer ${accessToken}`,
          });
          console.log("response",response.data)
        if (Array.isArray(response.data)) {
          setWorkouts(response.data);
          setFilteredWorkouts(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch workouts:', error);
      }
    };

    fetchWorkouts();
  }, [accessToken]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = workouts.filter(workout =>
      workout.name.toLowerCase().includes(value)
    );
    setFilteredWorkouts(filtered);
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <FitnessCenterIcon color="primary" />
        All Workout Plans
      </Typography>

      <TextField
        variant="outlined"
        placeholder="Search by workout name..."
        fullWidth
        value={searchTerm}
        onChange={handleSearch}
        InputProps={{
          startAdornment: <SearchIcon sx={{ mr: 1 }} color="action" />,
        }}
        sx={{ mb: 2 }}
      />

      <TableContainer component={Paper} elevation={3}>
        <Table>
          <TableHead sx={{ background: '#05b6b3' }}>
            <TableRow>
              <TableCell sx={{ color: '#fff' }}>#</TableCell>
              <TableCell sx={{ color: '#fff' }}>Workout Name</TableCell>
              <TableCell sx={{ color: '#fff' }}>Created By</TableCell>
              <TableCell sx={{ color: '#fff' }}>Visibility</TableCell>
              <TableCell sx={{ color: '#fff' }}>Created At</TableCell>
              <TableCell sx={{ color: '#fff' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredWorkouts.map((workout, index) => (
              <TableRow key={workout.id} hover>
                <TableCell>{index + 1}</TableCell>
                <TableCell
                  sx={{ cursor: 'pointer', color: '#1976d2', fontWeight: '500' }}
                  onClick={() => onWorkoutsClick(workout)}
                >
                  {workout.name}
                </TableCell>
                <TableCell>{workout.created_by}</TableCell>
                <TableCell>{workout.visibility}</TableCell>
                <TableCell>{new Date(workout.created_at).toLocaleString()}</TableCell>
                <TableCell>
                  <IconButton onClick={() => onWorkoutsClick(workout)} color="primary">
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {filteredWorkouts.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No workouts found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AllWorkOuts;
